import { FC, useState } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Box from "@mui/material/Box";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import "./style.css";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import jwtDecode from "jwt-decode";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { useObservable } from "src/framework/store/storeUtil";
import { LoginStore } from "src/framework/store/LoginStore";
import jwt from 'jwt-simple';
import { standAlonePage$ } from "src/framework/store/ApiEvents";

interface ITabItem {
    label: string;
    link: string;
}
interface ListTabs {
    tabs: ITabItem[];
}

const TabHeader: FC<ListTabs> = ({ tabs }) => {
    const location = useLocation();
    const history = useHistory();
    const pathname = location.pathname;
    const index = tabs.findIndex(i => i.link === pathname);
    const [value, setValue] = useState(index >= 0 ? index : 0);
    const permissoes:string[] = useObservable(LoginStore.permissoes) || [];
    const standAlone = useObservable(standAlonePage$)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    const handleClick = (url: string) => {
        history.push(url);
    };

    const handleRedirectProjetos = (segmento: string, venda: 'gerador' | 'avulso') => {
        const _tokenApi = LocalStorage.get("solar.token");
        if (_tokenApi) {
            const decoded: any = jwtDecode(_tokenApi);
            const _tokenLoja = {
                cnpj_cpf: decoded.user.cnpjCpf,
                token: decoded.token,
                refresh_token: decoded.refreshToken,
                type: decoded.type,
                customContaUnica: decoded.customContaUnica
            }
            const tLoja = jwt.encode(_tokenLoja, process.env.REACT_APP_TOKEN_KEY || "")
            let _url = `${encodeURIComponent("/")}&token=${tLoja}`;

            if (!!segmento) {
                _url += `&segmento=${segmento}`;
            }

            if (!!venda) {
                _url += `&venda=${venda}`;
            }

            window.location.href = `${process.env.REACT_APP_URL_LOJA}?${_url}`;
        }
    }
    return (
        <Box className="root">
            <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                centered
            >
                {tabs.map(tab => (
                    <Tab 
                        className="tab"
                        label={tab.label}
                        onClick={() => handleClick(tab.link)}
                        sx={{
                            '&.Mui-selected': {
                                color: 'primary.main',
                            },
                        }}
                    />
                ))}
                {PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_ONGRID, permissoes) && !standAlone &&
                    <Tab 
                        className="tab" 
                        color="primary" 
                        label="loja on grid"
                        onClick={() => handleRedirectProjetos("on", 'gerador')}
                    />
                }
                {PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_OFFGRID, permissoes) && !standAlone && 
                    <Tab 
                        className="tab" 
                        color="primary" 
                        label="loja off grid"
                        onClick={() => handleRedirectProjetos("off", 'gerador')}
                    />
                }
                {PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_AVULSO, permissoes) && !standAlone && 
                    <Tab 
                        className="tab" 
                        color="primary" 
                        label="avulso"
                        onClick={() => handleRedirectProjetos('', 'avulso')}
                    />
                }
            </Tabs>
        </Box>
    )
}

export default TabHeader;